<template>
  <div class="download-model-page pa-6" data-testid="download-model-page">
    <p>{{ statusMessage }}</p>
  </div>
</template>

<script>
export default {
  name: 'DownloadModelPage',
  props: {
    token: { type: String, required: true },
  },
  data() {
    return {
      statusMessage: '',
    };
  },
  created() {
    this.statusMessage = this.$t('model_download.redirecting');
    const apiPath = `/api/public/model-download/${encodeURIComponent(this.token)}`;
    // Full navigation so the browser treats the response as a file download.
    window.location.href = apiPath;
  },
};
</script>
